/**
 * Traço do ícone em função do tamanho em que ele é renderizado
 * (12/08/2026, decisão do Juan a partir do demo comparativo).
 *
 * A grade é sempre 24. O traço, não: um número fixo não pode servir a um
 * ícone de 9px e a um de 40px ao mesmo tempo. Com traço 1.6 fixo, um
 * ícone de 10px desenha 0,67px de verdade — sub-pixel, que vira borrão
 * cinza num monitor comum; um de 40px fica com fio quase invisível.
 *
 * Alvo: ~1px de traço renderizado, independente do tamanho. Daí a razão
 * `24 / render`.
 *
 * Os limites existem porque a razão pura estoura nas pontas: 24/8 daria
 * 3.0 (grosso a ponto de fechar os vãos do desenho) e 24/40 daria 0.6
 * (some). 1.0 a 2.6 cobre toda a faixa de tamanhos usada no sistema.
 *
 * Use em ícone de tamanho DINÂMICO (componente com prop `size`). Ícone
 * com width literal no JSX já tem o valor calculado gravado direto.
 */
export function tracoIcone(px) {
  const v = 24 / Number(px);
  return Math.round(Math.min(Math.max(v, 1.0), 2.6) * 100) / 100;
}
